import { render } from "./ChatWithAIComponent.vue?vue&type=template&id=df78538c&scoped=true"
import script from "./ChatWithAIComponent.vue?vue&type=script&lang=js"
export * from "./ChatWithAIComponent.vue?vue&type=script&lang=js"

import "./ChatWithAIComponent.vue?vue&type=style&index=0&id=df78538c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df78538c"]])

export default __exports__